// Document-level capture so this runs before Recharge's form-level capture handler stops propagation.
(function () {
  'use strict';

  if (window.__gpCartAddIntercept) return;
  window.__gpCartAddIntercept = true;

  function setLoading(host, submitButton, loading) {
    if (submitButton) {
      submitButton.classList.toggle('loading', loading);
      if (loading) submitButton.setAttribute('aria-disabled', 'true');
      else submitButton.removeAttribute('aria-disabled');
    }

    const spinner = host && host.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !loading);
  }

  // Mirrors product-form.js handleErrorMessage().
  function setError(host, message) {
    if (!host || host.dataset.hideErrors === 'true') return;

    const wrapper = host.querySelector('.product-form__error-message-wrapper');
    if (!wrapper) return;

    const target = wrapper.querySelector('.product-form__error-message');
    wrapper.toggleAttribute('hidden', !message);
    if (message && target) target.textContent = message;
  }

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target.closest && event.target.closest('product-form form[action*="/cart/add"]');
      if (!form) return;

      // Fall back to the native path if the state module or drawer is missing.
      const drawer = document.querySelector('gp-cart-drawer');
      if (!window.cartState || !drawer) return;

      const host = form.closest('product-form');
      const submitButton = form.querySelector('[type="submit"]');

      if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;

      event.stopPropagation();
      event.preventDefault();

      setError(host, false);
      setLoading(host, submitButton, true);

      window.cartState
        .add(new FormData(form))
        .then(function () {
          drawer.open(submitButton || undefined);
        })
        .catch(function (error) {
          const message =
            (error && error.cartError && (error.cartError.description || error.cartError.message)) ||
            (error && error.message) ||
            (window.cartStrings && window.cartStrings.error) ||
            'There was an error while updating your cart. Please try again.';
          setError(host, message);
        })
        .finally(function () {
          setLoading(host, submitButton, false);
        });
    },
    true
  );
})();
